import { assign } from 'lodash';
import { constants } from '../constants/common';

interface IApp {
  isLoaded: boolean;
  isAuthenticated: boolean;
  isNavigationOpen: boolean;
  isGlobalAdmin: boolean;
  user: any;
  navigations: any;
  formData: any;
  apiData: any;
  formInstructions: any;
  query: any;
  reloadFor: null | 'Task',
  candidateId: null | string,
  params: null | object,
  cache: {
    [key: string]: {
      data?: any;
      error?: any;
      lastFetched: number;
    };
  };
}

const initialState: IApp = {
  isLoaded: false,
  isAuthenticated: false,
  isNavigationOpen: false,
  isGlobalAdmin: false,
  user: null,
  navigations: null,
  formData: null,
  apiData: null,
  formInstructions: null,
  query: null,
  reloadFor: null,
  candidateId: null,
  params: null,
  cache: {}
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'APP_NAVIGATIONS':
      return assign({}, state, {
        navigations: action.navigations,
      });

    case 'APP_TABS':
      return assign({}, state, {
        tabs: action.tabs
      });
    case 'APP_LOADED':
      return assign({}, state, {
        isLoaded: true,
      });
    case 'APP_AUTHENTICATED':
      return assign({}, state, {
        isAuthenticated: true,
        user: { ...action.user, access: action.access },
      });
    case 'APP_UNAUTHENTICATED':
      return assign({}, state, {
        isAuthenticated: false,
        isGlobalAdmin: false,
        user: null,
      });
    case 'APP_ENABLE_ADMIN':
      return assign({}, state, {
        isGlobalAdmin: true,
      });
    case 'APP_DISABLE_ADMIN':
      return assign({}, state, {
        isGlobalAdmin: false,
      });
    case 'NAVIGATION_OPEN':
      return assign({}, state, {
        isNavigationOpen: true,
      });
    case 'NAVIGATION_CLOSE':
      return assign({}, state, {
        isNavigationOpen: false,
      });
    case 'PATIENT_URL':
      return assign({}, state, {
        isPUBLIC: true,
      });
    case 'USER_FORM':
      return assign({}, state, {
        formData: action.formData,
      });
    case 'USER_FORM_DATA':
      return assign({}, state, {
        apiData: action.apiData,
        formData: action.formData,
      });
    case 'OPEN_DRAWER':
      return assign({}, state, {
        status: action.status,
        formData: action.formData
      });
    case 'REFRESH_TABLE':
      return assign({}, state, {
        refreshTable: action.refreshTable,
        query: action.hasOwnProperty("query")
          ? action.query
          : state.query,
      });
    case constants.RESET_QUERY:
      return assign({}, state, {
        query: null,
      });
    case 'OPEN_Modal':
      return assign({}, state, {
        modalType: action.modalType,
        formData: action.formData
      });
    case constants.INSTRUCTIONS_FOR_FORM:
      return assign({}, state, {
        formInstructions: action.formInstructions,
      });

    case constants.PARAMS:
      return assign({}, state, {
        params: action.params,
      });

    case constants.REFRESH_DATA:
      return assign({}, state, {
        reloadFor: action.reloadFor,
      });

    case constants.FULL_SCREEN_MODE:
      return { ...state, [constants.FULL_SCREEN_MODE]: action.payload };

    case 'API_REQUEST':
      return state; // You may handle loading state per-key if needed

    case 'API_SUCCESS':
      return {
        ...state,
        cache: {
          ...state.cache,
          [action.payload.key]: {
            data: action.payload.data,
            lastFetched: Date.now()
          }
        }
      };

    case 'API_FAILURE':
      return {
        ...state,
        cache: {
          ...state.cache,
          [action.payload.key]: {
            error: action.payload.error,
            lastFetched: Date.now()
          }
        }
      };


    case constants.CANDIDATE_ID:
      return { ...state, [constants.CANDIDATE_ID]: action.payload };

    default:
      return state;
  }
};
